import { Modal, Toast, ActivityIndicator } from "antd-mobile";
import React from "react";
import { request, origin } from "../request";
import styles from "../css/Yuyue.css";
import selfStyle from "../css/wechatBrower.css";
import { debug } from "../request";

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    // eslint-disable-next-line
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

/**
 * 自动登录
 */

let authLock = false;

export async function autologin() {
  // 防止并发重复调用
  if (authLock) {
    console.log("autologin 正在执行中，跳过重复调用");
    return Promise.resolve(false);
  }

  if (localStorage.getItem("openid")) {
    return Promise.resolve(true);
  }

  authLock = true;

  return new Promise((resolve) => {
    let code = getQueryVariable("code");
    let params = { code: code };
    let settled = false;

    const done = (result) => {
      if (settled) return;
      settled = true;
      authLock = false;
      resolve(result);
    };

    request("index/auth", params, ({ data }) => {
      if (data.code === 1) {
        localStorage.setItem("head_image", data.data.head_image);
        localStorage.setItem("nickname", data.data.nickname);
        localStorage.setItem("openid", data.data.openid);
        done(true);
      } else {
        Toast.fail("微信登陆错误，请联系管理员！");
        done(false);
      }
    });

    // 超时保护：10 秒后自动释放锁，防止死锁
    setTimeout(() => {
      done(false);
    }, 10000);
  });
}

/**
 * 检查微信token
 * @returns
 */
export async function checkToekn() {
  if (!debug) {
    if (localStorage.getItem("openid")) {
      console.log("token!!!!!!!!!!!!:", localStorage.getItem("openid"));
      return Promise.resolve(1);
    } else {
      // 判断是否是微信浏览器
      let _is_wechat = is_wechat();
      if (_is_wechat) {
        if (getQueryVariable("code") && (!localStorage.getItem("openid"))) {
          let res = await autologin();
          return Promise.resolve(res);
        } else {
          return Promise.resolve(0);
        }
      } else {
        Toast.fail("请用微信浏览器打开");
        return Promise.resolve(0);
      }
    }
  } else {
    return Promise.resolve(1);
  }
}

/**
 * 判断是否是微信浏览器
 * @returns
 */
export function is_wechat() {
  // eslint-disable-next-line
  var ua = window.navigator.userAgent.toLowerCase();
  var patt1 = new RegExp(/micromessenger/);
  // eslint-disable-next-line
  if (patt1.test(ua)) {
    return true;
  } else {
    Toast.fail("必须在微信浏览器内打开:" + ua);
    request("index/log_userAgent", { userAgent: ua }, ({ data }) => { });
    return false;
  }
}

/**
 * 检查是否是手机号
 * @param {*} v
 * @returns
 */
export function checkPhone(v) {
  if (!/^1[3456789]\d{9}$/.test(v)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 检查是否是邮箱
 * @param {*} v
 * @returns
 */
export function checkEmail(v) {
  var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+(\.[a-zA-Z]{2,20}){1,5}$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 只允许中文
 * @param {*} v
 * @returns
 */
export function checkChinese(v) {
  var reg = /^[\u0391-\uFFE5]+$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 只允许中文 跟括号
 * @param {*} v
 * @returns
 */
export function checkChineseP(v) {
  var reg = /^[\u0391-\uFFE5\(\)\（\）]{0,50}$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 只允许英文
 * @param {*} v
 * @returns
 */
export function checkEng(v) {
  var reg = /^[A-Za-z]+$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 允许中英文和空格
 * @param {*} v
 * @returns
 */
export function checkZE(v) {
  var reg = /^[\u0391-\uFFE5A-Za-z ]{0,20}$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 是否是11位内数字
 * @param {*} v
 * @returns
 */
export function checkNum(v) {
  var reg = /^\d{0,11}$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 是否是10位数字
 * @param {*} v
 * @returns
 */
export function checkNum2(v) {
  var reg = /^\d{10}$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 是否是正整数
 * @param {*} v
 * @returns
 */
export function checkNumber(v) {
  var reg = /(^[1-9][0-9]{0,3}$)/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 检查纳税号
 * @param {*} Code
 * @returns
 */
export function CheckSocialCreditCodeOrg(Code) {
  var patrn = /^[0-9A-Z]+$/;
  //18位校验及大写校验
  if (Code.length !== 18 || patrn.test(Code) === false) {
    return false;
  } else {
    var Ancode; //信用代码/税号的每一个值
    var Ancodevalue; //信用代码/税号每一个值的权重
    var total = 0;
    var weightedfactors = [
      1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28,
    ]; //加权因子
    var str = "0123456789ABCDEFGHJKLMNPQRTUWXY";
    //不用I、O、S、V、Z
    for (var i = 0; i < Code.length - 1; i++) {
      Ancode = Code.substring(i, i + 1);
      Ancodevalue = str.indexOf(Ancode);
      total = total + Ancodevalue * weightedfactors[i];
      //权重与加权因子相乘之和
    }
    var logiccheckcode = 31 - (total % 31);
    if (logiccheckcode === 31) {
      logiccheckcode = 0;
    }
    var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
    var Array_Str = Str.split(",");
    logiccheckcode = Array_Str[logiccheckcode];

    var checkcode = Code.substring(17, 18);
    if (logiccheckcode !== checkcode) {
      return false;
      // alert("不是有效的统一社会信用编码！");
    } else {
      return true;
    }
  }
}

export function getId(name) {
  return document.getElementById(name).value;
}

/**
 * 检查是否是数字或大写英文
 * @param {*} v
 * @returns
 */
export function checkNumOrEN(v) {
  var reg = /^[0-9A-Z]*$/;
  if (reg.test(v)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 三个选项
 * @param content
 * @param cancelFunc
 * @param enterFunc
 */
export const showAlert = ({ content, cancelFunc, enterFunc }) => {
  const alertInstance = Modal.alert("温馨提醒", content, [
    {
      text: "否",
      onPress: cancelFunc.bind(this),
      style: { color: "#ddd" },
    },
    { text: "是", onPress: enterFunc.bind(this), style: { color: "black" } },
    {
      text: "取消",
      onPress: () => {
        alertInstance.close();
      },
      style: { color: "red" },
    },
  ]);
  // setTimeout(() => {
  //   // 可以调用close方法以在外部close
  //   console.log("auto close");
  //   alertInstance.close();
  // }, 50000);
};

/**
 * 两个选项
 * @param {*} param0
 */
export const showAlert2 = ({ content, cancelFunc, enterFunc }) => {
  const alertInstance = Modal.alert("温馨提醒", content, [
    {
      text: "否",
      onPress: cancelFunc.bind(this),
      style: { color: "#ddd" },
    },
    { text: "是", onPress: enterFunc.bind(this), style: { color: "black" } },
  ]);
  // setTimeout(() => {
  //   // 可以调用close方法以在外部close
  //   console.log("auto close");
  //   alertInstance.close();
  // }, 50000);
};


export const showAlert3 = ({ content, cancelFunc, enterFunc }) => {
  const alertInstance = Modal.alert("温馨提醒", content, [
    {
      text: "返回填写",
      onPress: cancelFunc.bind(this),
      style: { color: "#ddd" },
    },
    { text: "确认提交", onPress: enterFunc.bind(this), style: { color: "black" } },
  ]);
};

export const Loading = ({ loading }) => {
  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: "rgba(0,0,0,0.2)",
          dispaly: "flex",
        }}
      >
        <ActivityIndicator toast animating={loading} />
      </div>
    );
  } else {
    return <div></div>;
  }
};

export const Add = ({ click }) => {
  return (
    <label
      className={styles.font}
      style={{
        marginTop: "0.1rem",
        marginLeft: "0.633333rem",
        color: "rgb(174, 92, 201)",
      }}
      onClick={click}
    >
      请继续添加
    </label>
  );
};

export const Button = ({ title, onClick, style }) => {
  return (
    <div
      className={selfStyle.button}
      onClick={onClick.bind(this)}
      style={style}
    >
      {title}
    </div>
  );
};

export const Img = ({ item, onClick, hide = false }) => {
  if (!item.url) {
    return <div></div>;
  }
  let _zun = item.filename.split(".")[1];
  let NImg;
  switch (_zun) {
    case "png":
    case "jpg":
    case "svg":
    case "jpeg":
      NImg = <img src={origin + item.url} alt="" className={styles.IMG} />;
      break;
    case "doc":
    case "docx":
      NImg = (
        <img
          src={require("../static/文件.jpg")}
          alt=""
          className={styles.IMG}
        />
      );
      break;
    case "pdf":
      NImg = (
        <img src={require("../static/pdf.jpg")} alt="" className={styles.IMG} />
      );
      break;
    default:
      NImg = (
        <img
          src={require("../static/file.jpg")}
          alt=""
          className={styles.IMG}
        />
      );
      break;
  }

  return (
    // <div className={styles.photoWeaper}>
    //   <div>
    //     {NImg}

    //   </div>
    //   <p onClick={onClick.bind(this)} style={{ display: hide && "none" }}>
    //     删除
    //   </p>
    //   <p
    //       // style={{
    //       //   fontSize: "0.7rem",
    //       //   whiteSpace: "nowrap",
    //       //   overflow: "hidden",
    //       //   textOverflow: "ellipsis",
    //       //   color: "black",
    //       //   top: "0",
    //       // }}
    //     >
    //       {item.filename}
    //     </p>
    // </div>
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: "2rem",
        }}
      >
        {NImg}
        <p
          onClick={onClick.bind(this)}
          className={styles.delete}
          style={{ display: hide && "none" }}
        >
          删除
        </p>
      </div>
      <p className={styles.filename} style={{ top: hide && "0rem" }}>
        {item.filename}
      </p>
    </div>
  );
};

export function dateFormat(fmt, _date) {
  let ret;
  var date = new Date(_date); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}

// export function timeTostr(dateTime) {
//   let date = new Date(dateTime*1000);
//   let year = date.getFullYear();
//   let month = date.getMonth()+1;
//   let day = date.getDate();
//   month = month < 10 ? "0"+month:month;
//   day = day < 10 ? "0"+day:day;
//   let dateStr = year + '-' + month + '-' + day;
//   return dateStr;
// }




// WEBPACK FOOTER //
// ./src/tools/wechatBrower.js